import { diContainer } from '../libs/container';

export const useContainer = <T>(service: new (val: any) => T): T => {
    return diContainer.get(service);
};
